import { render, staticRenderFns } from "./bkinfo.vue?vue&type=template&id=485ef9b3&scoped=true"
import script from "./bkinfo.vue?vue&type=script&lang=js"
export * from "./bkinfo.vue?vue&type=script&lang=js"
import style0 from "./bkinfo.vue?vue&type=style&index=0&id=485ef9b3&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485ef9b3",
  null
  
)

export default component.exports